import {
  ContentRequest,
  Medium,
  Service,
  TaxGuideResponse,
  TemplateType,
  useDownloadTaxGuidePDF,
  useDownloadTaxGuideWord,
  useTaxGuideContent,
} from '@/api/tax-guide';
import React, { Dispatch, SetStateAction } from 'react';
import { createContext, PropsWithChildren, useState } from 'react';

type TaxGuideContextProps = {
  content?: TaxGuideResponse;
  updateRequest: Dispatch<SetStateAction<Partial<ContentRequest>>>;
  isPending: boolean;
  isFetching: boolean;
  downloadPDFCall: () => void;
  downloadWordCall: () => void;
  refetch: () => void;
  isDownloading: boolean;
  isDownloadingWord: boolean;
};

export const TaxGuideContext = createContext<TaxGuideContextProps>({
  content: undefined,
  updateRequest: () => {
    return;
  },
  isFetching: false,
  isPending: false,
  downloadPDFCall: () => {
    return;
  },
  refetch: () => {
    return;
  },
  isDownloading: false,
  downloadWordCall: () => {
    return;
  },
  isDownloadingWord: false,
});

type DefaultRequestProps = {
  directLoginId?: string;
  templateType: TemplateType;
  companyId: string;
  language: string;
};

export function TaxGuideContextProvider({
  children,
  ...props
}: PropsWithChildren<DefaultRequestProps>) {
  const defaultRequest = {
    planId: '',
    countryId: '',
    stateId: '',
    medium: Medium.html,
    serviceName: Service.tax_guide,
    taxCalculationPopupList: null,
    taxAdvantage: null,
    ...props,
  };
  const [request, updateRequest] = useState<ContentRequest>(defaultRequest);

  const {
    data: content,
    isPending,
    isFetching,
    refetch,
  } = useTaxGuideContent(request);

  const { mutate, isPending: isDownloading } = useDownloadTaxGuidePDF({
    ...request,
    medium: Medium.pdf,
  });

  const { mutate: wordMutate, isPending: isDownloadingWord } =
    useDownloadTaxGuideWord({
      ...request,
      medium: Medium.word,
    });
  return (
    <TaxGuideContext.Provider
      value={{
        content,
        updateRequest: value => {
          updateRequest({
            ...request,
            ...value,
          });
        },
        isPending,
        isFetching,
        downloadPDFCall: mutate,
        downloadWordCall: wordMutate,
        refetch,
        isDownloading,
        isDownloadingWord,
      }}
    >
      {children}
    </TaxGuideContext.Provider>
  );
}
